"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var redux_1 = require("redux");

var ids_1 = __importDefault(require("./ids"));

var loadedOnce_1 = __importDefault(require("./loadedOnce"));

var params_1 = __importDefault(require("./params"));

var selectedIds_1 = __importDefault(require("./selectedIds"));

var total_1 = __importDefault(require("./total"));

exports.default = redux_1.combineReducers({
  ids: ids_1.default,
  loadedOnce: loadedOnce_1.default,
  params: params_1.default,
  selectedIds: selectedIds_1.default,
  total: total_1.default
});